import React from 'react';
import { Box, Typography } from '@mui/material';
import { Gauge, gaugeClasses } from '@mui/x-charts';

const BatteryGauge = ({
  soc,
  statusText,
}) => {
  const hasSoc = soc != null;

  return (
    <Box sx={{
      display: "inline-flex",
      position: "relative",
      height: 110,
    }}>
      <Gauge
        cornerRadius="50%"
        value={hasSoc ? soc : 0}
        startAngle={-90}
        endAngle={90}
        innerRadius="82%"
        outerRadius="100%"
        margin={0}
        width={220}
        height={110}
        sx={{
          [`& .${gaugeClasses.valueText}`]: {
            display: "none",
          },
          [`& .${gaugeClasses.valueArc}`]: {
            fill: "var(--c-brand)",
          },
          [`& .${gaugeClasses.referenceArc}`]: {
            fill: "var(--c-border)",
          },
        }}
      />

      {/* Centered value */}
      <Box sx={{
        position: "absolute",
        bottom: 0,
        left: "50%",
        transform: "translateX(-50%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 0.5,
      }}>
        <Typography sx={{
          fontSize: 40,
          fontWeight: 600,
          lineHeight: 1,
          letterSpacing: "-0.02em",
          fontVariantNumeric: "tabular-nums",
          color: hasSoc ? "var(--c-text)" : "var(--c-border-strong)",
        }}>
          {hasSoc ? `${soc}%` : "–"}
        </Typography>
        {statusText && (
          <Typography sx={{
            fontSize: 12,
            fontWeight: 600,
            color: "var(--c-text-3)",
            backgroundColor: "var(--c-muted)",
            borderRadius: "999px",
            px: 1,
            py: 0.25,
            lineHeight: 1.4,
            whiteSpace: "nowrap",
          }}>
            {statusText}
          </Typography>
        )}
      </Box>
    </Box>
  )
}

export default BatteryGauge;
